import { render } from "./ShipmentCostDetail.vue?vue&type=template&id=385a3994&scoped=true"
import script from "./ShipmentCostDetail.vue?vue&type=script&lang=js"
export * from "./ShipmentCostDetail.vue?vue&type=script&lang=js"

import "./ShipmentCostDetail.vue?vue&type=style&index=0&id=385a3994&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-385a3994"]])

export default __exports__